export const isValidYear = year => {
   year = (year || '').toString();
   if (!year || year.length < 4) {
      return false;
   }
   
   year = parseInt(year, 10);
   if (isNaN(year)) return false;
   const now = new Date();
   const currentYear = now.getFullYear();
   if (isNaN(year) || year < 1900 || year > currentYear) {
      return false;
   }
   
   return true;
};